import React from "react";
import { AUTH_BASE_URL } from "../../../redux/actions/dashboard/env.variables";
// components
import LayoutContent from "./Layout.content";
interface Props {
  // redux
  logout: () => void,
  auth: any;
}

export default ({
  logout,
  auth
}: Props) => {

  const redirectToAxumAccount = () => {
    window.location.href = AUTH_BASE_URL;
  };

  return (
    <LayoutContent
      auth = {auth}
      logout = {logout}
      redirectToAxumAccount = {redirectToAxumAccount}
    />
  );
};

